import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type MetaService from 'marcemira/services/meta';
import type RouterService from '@ember/routing/router-service';
import { generateWebsiteSchema, generateBreadcrumbSchema } from 'marcemira/utils/schema-org';

export default class ErrorRoute extends Route {
  @service declare meta: MetaService;
  @service declare router: RouterService;

  afterModel() {
    const currentURL = `https://marcemira.com${this.router.currentURL}`;

    // Set SEO metadata for 404 page
    this.meta.title = '404 - Page Not Found';
    this.meta.description = "The page you're looking for doesn't exist. Return to Marcelo Mira's portfolio homepage or explore other sections.";
    this.meta.canonicalUrl = currentURL;

    // Set meta tags - tell search engines NOT to index 404 pages
    this.meta.setTags([
      { name: 'robots', content: 'noindex, follow' }, // Don't index 404s, but follow links
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: currentURL },
    ]);

    // Generate Website schema
    const websiteSchema = generateWebsiteSchema({
      name: 'Marcemira - Marcelo Mira Portfolio',
      url: 'https://marcemira.com',
      description: 'Personal portfolio of Marcelo Mira, a full-stack web developer and UX/UI designer.',
      author: 'Marcelo Mira'
    });

    // Generate Breadcrumb schema
    const breadcrumbSchema = generateBreadcrumbSchema([
      { name: 'Home', url: 'https://marcemira.com' },
      { name: '404 - Page Not Found', url: currentURL }
    ]);

    // Add structured data
    this.meta.scriptTags = [
      {
        type: 'application/ld+json',
        id: 'structured-data-website',
        content: JSON.stringify(websiteSchema)
      },
      {
        type: 'application/ld+json',
        id: 'structured-data-breadcrumb',
        content: JSON.stringify(breadcrumbSchema)
      }
    ];

    // Render meta tags
    this.meta.renderMetaToHeader();
  }
}

